import { Input, Select } from '@new-components/elements';
import { useFormContext } from '@hooks/react-hook-form';
import {
  ApplicationDataResponse,
  useRGetApplicationData,
} from '@repositories/new-application';

import ApplicationCard from '../../../../../application-card';
import SectionTitle from '../../../../../section-title';
import { SectionProps } from '../../../../types';

const BiologicalFamily = (props: SectionProps) => {
  const { readonly } = props;
  const {
    fieldsRef,
    formState: { isSubmitting, isSubmitSuccessful },
    trigger,
  } = useFormContext();
  const {
    data,
    isLoading: isLoadingGetApplicationData,
    isError: isErrorGetApplicationData,
    refetch: refetchGetApplicationData,
  } = useRGetApplicationData<ApplicationDataResponse<2>>({
    page: 2,
  });

  return (
    <ApplicationCard>
      <SectionTitle title='Informasi Kontak Darurat' />
      <Select
        ref={(e) => (fieldsRef.current['kinRelationship'] = e)}
        name='kinRelationship'
        label='Hubungan'
        placeholder='pilih'
        disabled={
          readonly ||
          isLoadingGetApplicationData ||
          (isSubmitting && !isSubmitSuccessful)
        }
        onFocus={() => isErrorGetApplicationData && refetchGetApplicationData()}
        options={data?.data.kinRelationships}
      />
      <Input
        ref={(e) => (fieldsRef.current['kinName'] = e)}
        name='kinName'
        disabled={readonly || (isSubmitting && !isSubmitSuccessful)}
        label='Nama Kontak Darurat'
        placeholder='Nama Kontak Darurat'
      />
      <Input
        ref={(e) => (fieldsRef.current['kinMobilePhone'] = e)}
        type='tel'
        name='kinMobilePhone'
        disabled={readonly || (isSubmitting && !isSubmitSuccessful)}
        label='Nomor HP Kontak Darurat'
        onKeyUp={() => trigger('kinMobilePhone')}
        placeholder='08xxxxxxxxxx'
      />
    </ApplicationCard>
  );
};

export default BiologicalFamily;
